import request from '@/utils/request'

export function getCapthcha() {
    return request({
      url: '/getVcodeImage',
      method: 'get'
    })
}

export function checkIsUnique(query) {
  return request({
      url: '/isUnique',
      method:'get',
      params:query
  })
}

export function uploadImage(data) {
  return request({
      url:'/api/uploadImg',
      method:'post',
      data
  })
}

export function uploadWithParams(data,params) {
  return request({
      url:'/api/uploadFile',
      method:'post',
      data,
      params:params
  })
}

export function fetchAttachList(query){
  return request({
      url:'api/getAttachmentList',
      method:'get',
      params:query
  })
}

export function createAttachment(data){
  return request({
      url:'/api/addAttachment',
      method:'post',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      data
  })
}

export function deleteAttachment(data) {
  return request({
      url:'/api/removeAttachment',
      method:'post',
      data
  })
}

export function fetchConfigList(query){
  return request({
      url:'/api/getConfigList',
      method:'get',
      params:query
  })
}

export function createConfig(data) {
  return request({
      url:'/api/addConfig',
      method:'post',
      data
  })
}

export function deleteConfig(data) {
  return request({
      url:'/api/removeConfig',
      method:'post',
      data
  })
}

export function getRoutes() {
  return request({
      url: '/api/getUserRoutes',
      method: 'get'
  })
}

export function fetchPageRights(query) {
  return request({
      url:'/api/getUserPageRights',
      method: 'get',
      params:query
  })
}